import InternalCard from './Card';
import Grid from './Grid';
import Meta from './Meta';
var Card = InternalCard;
Card.Grid = Grid;
Card.Meta = Meta;
export default Card;